import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { Nillable } from '@web/utils';
import { PublicOrderItemAttributeResponse } from './public-order-item-attribute.response';
import { ProductType } from '../../../shared/enums';
import { OrderItemRefundSummaryResponse } from '../../../shared/api/responses';
import { PublicOrderItemComponentGroupResponse } from './public-order-item-component-group.response';

@jsonObject
export class PublicOrderItemResponse {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly subName?: Nillable<string>;

  @jsonMember(String)
  public readonly slug?: Nillable<string>;

  @jsonMember(String)
  public readonly type!: ProductType;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(Number)
  public readonly unitPrice!: number;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(OrderItemRefundSummaryResponse)
  public readonly refundSummary?: Nillable<OrderItemRefundSummaryResponse>;

  @jsonArrayMember(PublicOrderItemAttributeResponse)
  public readonly attributes?: Nillable<PublicOrderItemAttributeResponse[]>;

  @jsonArrayMember(PublicOrderItemComponentGroupResponse)
  public readonly componentGroups?: Nillable<
    PublicOrderItemComponentGroupResponse[]
  >;
}
